import React from 'react'

export const IconCross = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" fill="currentColor" {...props}>
        <path fill-rule="evenodd" d="M487.148 1053.48l5.66-5.66c1.56-1.56 1.56-4.1 0-5.66 -1.57-1.57-4.11-1.57-5.67 0l-5.67 5.66 -5.67-5.66c-1.57-1.57-4.1-1.57-5.67 0 -1.57 1.56-1.57 4.1 0 5.66l5.66 5.66 -5.67 5.67c-1.57 1.56-1.57 4.1 0 5.66 1.56 1.57 4.1 1.57 5.66 0l5.66-5.66 5.66 5.66c1.56 1.57 4.1 1.57 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.67-5.67" transform="translate(-469-1041)"></path>
    </svg>
  )
}
